// Background particles vertex shader
// Slowly drifting ambient dust/smoke particles.

uniform float uTime;

attribute float aSize;
attribute float aSpeed;
attribute float aOffset;

varying float vAlpha;

void main() {
    vec3 pos = position;

    // Drift upward, wrap around using aOffset as starting Y phase
    float yProgress = mod(pos.y + uTime * aSpeed + aOffset, 24.0) - 12.0;
    pos.y = yProgress;

    // Gentle horizontal sway
    pos.x += sin(uTime * 0.3 * aSpeed + aOffset * 6.28) * 0.15;
    pos.z += cos(uTime * 0.25 * aSpeed + aOffset * 6.28) * 0.15;

    // Fade near top and bottom of volume
    vAlpha = 1.0 - abs(yProgress / 12.0);
    vAlpha = pow(vAlpha, 1.5) * 0.35;

    vec4 mvPosition = modelViewMatrix * vec4(pos, 1.0);
    gl_PointSize = aSize * (200.0 / -mvPosition.z);
    gl_Position  = projectionMatrix * mvPosition;
}
